export default {
  "siteName": "yoybuy.hair",
  "siteTagline": "YOYBUY Sheet — Умная система заказов из Китая",
  "heroTitle": "YOYBUY Sheet",
  "heroSubtitle": "Ваш проводник в мире покупок из Китая",
  "heroDescription": "Полное руководство по YOYBUY Spreadsheet. Узнайте, как использовать систему управления заказами из Китая для выгодных покупок. Kakobuy Spreadsheet, Superbuy Spreadsheet — сравнение и лучшие стратегии.",
  "goToShop": "Перейти в магазин",
  "buyNow": "Купить сейчас",
  "yoybuySheet": "yoybuy sheet",
  "allCategories": "Все категории",
  "categoriesTitle": "Категории товаров",
  "categoriesSubtitle": "Для каждого стиля",
  "aboutTag": "О YOYBUY Sheet",
  "aboutTitle1": "Почему YOYBUY Sheet —",
  "aboutTitle2": "это ваш идеальный",
  "aboutTitle3": "инструмент для заказов",
  "aboutContent": "YOYBUY Sheet — это инновационная система управления заказами, созданная специально для покупателей из Китая. В отличие от обычных приложений, spreadsheet-система обеспечивает полную прозрачность каждого этапа: от выбора товара до доставки. Вы получаете доступ к детальной таблице с ценами, статусами заказов и сроками доставки. Миллионы пользователей уже оценили удобство YOYBUY Spreadsheet для организации международных покупок. Система позволяет отслеживать все заказы в одном месте, сравнивать цены разных поставщиков и экономить до 30% на комиссиях. Интуитивно понятный интерфейс и гибкие настройки делают YOYBUY Sheet идеальным решением как для новичков, так и для опытных покупателей. Присоединяйтесь к сообществу и откройте для себя новый уровень удобства при заказах из Китая.",
  "usefulArticles": "Полезные статьи",
  "articlesDescription": "Узнайте больше о YOYBUY Spreadsheet и сравните с другими системами управления заказами. Читайте наши подробные руководства и обзоры.",
  "readMore": "Читать далее",
  "ctaTitle": "ОТКРОЙТЕ YOYBUY SHEET СЕЙЧАС",
  "ctaSubtitle": "Присоединяйтесь к тысячам довольных покупателей",
  "ctaButton": "ПЕРЕЙТИ НА KASPREADSHEET",
  "testimonialsTag": "Отзывы покупателей",
  "testimonialsTitle": "Что говорят покупатели",
  "testimonialsSubtitle": "О системе YOYBUY Sheet",
  "footerCategories": "Категории",
  "footerArticles": "Статьи",
  "footerAbout": "О нас",
  "footerHelp": "Помощь",
  "footerCopyright": "© 2026 yoybuy.hair. Все права защищены.",
  "backToHome": "← Вернуться на главную yoybuy.hair",
  "breadcrumbHome": "Главная",
  "breadcrumbArticles": "Статьи",
  "articleReadAlso": "Читайте также",
  "articleReadAlsoDesc": "Другие полезные материалы о spreadsheet-системах для заказов из Китая",
  "navOpen": "Открыть меню",
  "navClose": "Закрыть меню",
  "categorySelect": "Все категории"
}